import React from 'react';
import Box from '../components/Box';

export const AboutWebUI = () => {
  return (
    <Box style={{ backgroundColor: '#F8F8F8', border: "2px solid #96CCFF" }}>
      <h2 className='mt0 mb3 arial fw2 f3 charcoal'>What is TKGGBS?</h2>
      <ul className='pl3'>
          <li className='mb2'><span className='greenmod u'>Purchase tokens</span>&nbsp;&mdash; In our dapp, you can purchase tokens corresponding to an amount of gold.</li>
          <li className='mb2'><span className='greenmod u'>Sell tokens</span>&nbsp;&mdash; In our dapp, you can also sell those tokens.</li>
          <li className='mb2'><span className='greenmod u'>Refer to your data</span>&nbsp;&mdash; You can always refer to your transaction history, profit; loss and other information.</li>
          <li className='mb2'><span className='greenmod u'>Administered by the system owner</span>&nbsp;&mdash; The system owner, the system department, can execute any operations.</li>
      </ul>
    </Box>
  )
}

export default AboutWebUI;
